import CardActionButtonRoot, { Props } from './CardActionButton'

export default function CardActionButton(props: Props) {
  return <CardActionButtonRoot {...props} />
}
